/* CaptureNameComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./CaptureNameRenderer");
const _ = require("lodash");
const CaptureScheduleComponent = require("../../../../../../lib/actions/veils/schedule/ScheduleVeilComponent");

class CaptureNameComponent extends EventEmitter {
    constructor(
        logger,
        userSession,
        activeView,
        selectedDeviceIds,
        deviceEntity,
        modalUserFeedback
    ) {
        super();
        this._titleText = "Capture - Snapshot Name";
        this._logger = logger;
        this._userSession = userSession;
        this._activeView = activeView;
        this._selectedDeviceIds = selectedDeviceIds;
        this._DeviceEntity = deviceEntity;
        this._modalUserFeedback = modalUserFeedback;

        this._hasBasicSearch = !_.isEmpty(
            _.get(this._activeView._userGridData.getBasicSearchData(), "filterQuery", {})
        );
        this._renderer = new Renderer(this);

        this.reject = this.reject.bind(this);
        this.resolve = this.resolve.bind(this);

        this._registerListeners();
        this._renderer.render();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/
    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    get titleText() {
        return this._titleText;
    }

    get logger() {
        return this._logger;
    }

    shutdown() {
        this._unregisterListeners();
        return this._renderer.shutdown().then(
            () => {
                this._renderer = undefined;
            },
            (err) => {
                this._logger.warn({error: err}, "CaptureNameComponent.shutdown() error");
            }
        );
    }

    startCapture(name, filter) {
        return this._getWorkTarget(filter).then((workTarget) => {
            let jobInputs = {
                description: name ? name : "",
            };
            return this._DeviceEntity
                .runCaptureWork(this._userSession.activeOrganization.id, workTarget, jobInputs, {
                    launchAndForget: true,
                })
                .then((result) => {
                    if (result.errorMsg) {
                        let err = new Error(result.errorMsg);
                        err.errorCode = "CaptureError";
                        err.errorMsg = result.errorMsg;
                        throw err;
                    }
                    if (
                        result.failed &&
                        result.failed.length > 0 &&
                        result.failed[0].errorCode === "StartJobError"
                    ) {
                        return Promise.reject(result.failed[0]);
                    }
                })
                .then(this.resolve, this.reject);
        });
    }

    setSchedule(name, filter) {
        this._getWorkTarget(filter).then((workTarget) => {
            return this._modalUserFeedback
                .displayCustom(
                    new CaptureScheduleComponent(this._logger, true, "Capture - Schedule", {
                        workType: "capture",
                        firstTime: true,
                    }),
                    {
                        dontHide: false,
                    }
                )
                .then((scheduleDef) => {
                    let displayName = name
                        ? name
                        : "Capture scheduled on " +
                          new Date().toLocaleDateString() +
                          " " +
                          new Date().toLocaleTimeString();
                    scheduleDef.workInput.description = displayName;
                    return this._DeviceEntity.scheduleCaptureWork(
                        this._userSession.activeOrganization.id,
                        displayName,
                        "",
                        scheduleDef.schedule,
                        workTarget,
                        scheduleDef.workInput
                    );
                })
                .then(this.resolve, this.reject);
        });
    }

    cancelAction() {
        let err = new Error("user rejected");
        err.userRejected = true;
        return this.reject(err);
    }

    reject(err) {
        this._context.reject(err);
    }
    resolve(action) {
        this._context.resolve(action);
    }

    // prettier-ignore
    set "$teve.ui.context" (context) { //jshint ignore:line
        this._context = context;
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/
    /**
     * Create workTarget Object from devices component selection
     * @param {String} selection
     * @returns {Object}
     */
    _getWorkTarget(selection) {
        return Promise.resolve().then(() => {
            if (selection === "all") {
                return {
                    entityType: "Device",
                    category: "entity",
                    method: "query",
                    query: {},
                };
            }
            if (selection === "selection") {
                return {
                    category: "entity",
                    entityType: "Device",
                    method: "multi",
                    ids: this._activeView.getSelectedDeviceIds().selectedRows,
                };
            }
            if (selection === "apply_current_filter") {
                return {
                    entityType: "Device",
                    category: "entity",
                    method: "query",
                    query: this._activeView._userGridData.getAdvancedSearchData(),
                };
            }
            if (selection === "current_search_results") {
                return this._activeView._DeviceEntityDef
                    .loadDevices(
                        this._activeView._gameEditor._activeOrgId,
                        _.get(
                            this._activeView._userGridData.getBasicSearchData(),
                            "filterQuery",
                            {}
                        ),
                        {id: true}
                    )
                    .then((deviceIds) => {
                        let ids = deviceIds.map((device) => device.id);
                        return {
                            category: "entity",
                            entityType: "Device",
                            method: "multi",
                            ids,
                        };
                    });
            }
        });
    }

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = CaptureNameComponent;
